import { render, staticRenderFns } from "./tvr_team.vue?vue&type=template&id=d208c094"
import script from "./tvr_team.vue?vue&type=script&lang=js"
export * from "./tvr_team.vue?vue&type=script&lang=js"
import style0 from "./tvr_team.vue?vue&type=style&index=0&id=d208c094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports